// extracted by mini-css-extract-plugin
module.exports = {"dropArea":"dropArea__HWK47","accepted":"accepted__QhxhV","text":"text__yuDsa","formats":"formats__Uzlro","extensions":"extensions__Rv3v0"};